module.exports = __webpack_public_path__ + "img/fb.8f10aced.svg";